import type { ListParams } from '../type';
import baseKey from './_baseKey';

const crewDomainKey = () => baseKey.domainKey('crew');

/**
 * 크루 관련 쿼리키 제너레이터
 */
const crewKey = {
  /**
   * @returns 크루 도메인 기본 쿼리키 (getter)
   * @example ['crew']
   */
  domain() {
    return crewDomainKey();
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 페이지네이션 방식 크루 리스트 데이터 요청 쿼리키
   * @example ['crew', 'list', 'page', {...listParams}]
   */
  listByPage(listParams?: ListParams) {
    const coreKey = baseKey.listKey(crewDomainKey(), 'page');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param listParams 리스트 파라미터
   * @returns 무한 스크롤 방식 크루 리스트 데이터 요청 쿼리키
   * @example ['crew', 'list', 'scroll', {...listParams}]
   */
  listByScroll(listParams?: ListParams) {
    const coreKey = baseKey.listKey(crewDomainKey(), 'scroll');
    return listParams ? [...coreKey, listParams] : coreKey;
  },
  /**
   * @param id 크루 리스트 아이템 ID
   * @returns 크루 상세 데이터 요청 쿼리키
   * @example ['crew', 'detail', 1]
   */
  detailById(id: number) {
    return [...baseKey.itemKey(crewDomainKey(), 'detail'), id];
  },
};

export default Object.freeze(crewKey);
